import { render } from "./Footer2.vue?vue&type=template&id=46176588"
import script from "./Footer2.vue?vue&type=script&lang=js"
export * from "./Footer2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__